export const lspLoginUrl = process.env.REACT_APP_LOGIN_PAGE_URL;

export const phoneNrRegex = /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g;

